import { SOURCE_CONTEXT } from '@atlassian/twc-xflow-modal/constants';

export function toSourceContext(
	context: string | undefined,
): (typeof SOURCE_CONTEXT)[keyof typeof SOURCE_CONTEXT] {
	return (
		Object.values(SOURCE_CONTEXT).find((sourceContext) => sourceContext === context) ??
		SOURCE_CONTEXT.JIRA_PLATFORM_TOP_CTA
	);
}
